const RoleEnum = Object.freeze({
  SUPERADMIN: {
    value:"SUPERADMIN",
    string:"Super admin"
  },
  ADMIN: {
    value:"ADMIN",
    string:"Admin"
  }, 
  LINGUIST: {
    value:"LINGUIST",
    string:"Expert linguistique"
  } 
});


export default RoleEnum;